export default __webpack_public_path__ + "static/media/close-burger.c73f3db3.svg";